<section class="container">
  <div class="row mt-4">
    <div class="col-12">

      <div class="topNavbar mb-1">
        <button mat-button class="m-1" style="color:var(--warmOrange);" (click)="backTo();">
          <mat-icon>arrow_back_ios_new</mat-icon> {{'goBack' | translate}}
        </button>
        <span class="fs-5">Details</span>
        <div>
          <button mat-button class="m-1 secondary-gray-button-2" (click)="QRoptions()">
            <mat-icon> qr_code_2_add</mat-icon> Sample QR
          </button>
          <button mat-button class="m-1 orange-button" (click)="downloadQrZip()">
            <mat-icon>download</mat-icon> Download QR ZIP
          </button>
        </div>

      </div>

      <div class="my-4 section-title">
        <mat-icon class="custom-card-icon material-symbols-outlined">info</mat-icon>{{'tridys.tridy_info' | translate}}
      </div>

      <mat-card class="mb-2">
        <mat-card-content class="my-2">
          @if (titleValue && titleKey) {
            <span class="title-key">{{titleValue}}</span>
          }
          @if (subtitleValues && subtitleValues.length>0) {
            <div>
              @for (subtitle of subtitleValues; track subtitle) {
                <div class="subtitle-key my-1 font-weight-bold">
                  @if (subtitle?.contentType === 'public.image' && subtitleKeys) {
                    <span>{{subtitle.fileName}}</span>
                  }
                  @if (subtitle?.contentType !== 'public.image' && subtitleKeys) {
                    <span>{{subtitle}}</span>
                  }
                </div>
              }
              @if (subtitleKeys) {
                <mat-divider class="my-3"></mat-divider>
              }
            </div>
          }
          <!-- if content type has this defined, then those should be shown and set according to payload -->
          <span class="font-weight-bold">ID: </span> <span style="opacity:0.65;padding-right: 5px;">{{idToShow}}</span><mat-icon matTooltip="{{'copyToClipboard' | translate}}" [cdkCopyToClipboard]="idToShow" class="copy_id">content_copy</mat-icon><br>
          @if (tridyData && tridyData.creationDate) {
            <span class="font-weight-bold">{{'creation_date' | translate}}: </span>
            <span  style="opacity:0.65;">{{tridyData.creationDate.toDate() | date: 'dd.MM.yyyy, HH:mm'}}</span>
          }
        </mat-card-content>
      </mat-card>

      <div class="my-4 section-title">
        <mat-icon class="custom-card-icon material-symbols-outlined">task</mat-icon>{{'tridys.finished' | translate}}
      </div>
      <mat-card class="mb-2">
        <mat-card-content class="my-2">
          @if (finishedTasks) {
            <div>
              @for (ftask of finishedTasks; track ftask) {
                <div class="item-content my-1" (click)="redirectTo(ftask)">
                  <div class="d-flex flex-row flex-nowrap justify-content-between align-items-center">
                    <div class="d-flex flex-column flex-nowrap">
                      <span style="color:var(--warmOrange);">{{ftask.title}}</span>
                      <div>
                        <span class="text-muted">{{ftask.creationDate.toDate() | date:'dd.MM.yyyy, HH:mm' }}</span>
                        @if (ftask.timeStamp) {
                          <span class="text-muted">  - {{ftask.timeStamp.toDate() | date:'dd.MM.yyyy, HH:mm' }}</span>
                        }
                      </div>
                    </div>
                    <span class="material-symbols-outlined" style="color:var(--warmOrange);">
                      keyboard_arrow_right
                    </span>
                  </div>
                </div>
              }
            </div>
          }
          @if (finishedTasks.length==0) {
            <div class="p-3">
              <span class="text-muted">{{'tridys.no_finishedTasks' | translate}}</span>
            </div>
          }
        </mat-card-content>
      </mat-card>

      <!-- INCOMING -->
      @if (incoming && incoming.length!=0) {
        <div>
          <div class="my-4 section-title">
            <mat-icon class="custom-card-icon material-symbols-outlined">input</mat-icon>{{'workTask.incoming_tridys' | translate}}
          </div>
          <mat-card class="mb-2">
            <mat-card-content class="my-2">
              @for (incom of incoming; track incom) {
                <div class="item-content my-1" (click)="openTridyDetailsDialog(incom.tridyId)">
                  <div class="d-flex flex-row flex-nowrap justify-content-between align-items-center">
                    <div class="d-flex flex-column flex-nowrap">
                      @if (getTRIDYIdData(incom.tridyId, 'payload')) {
                        <div>
                          @if (getContentTypeFieldById(incom.contentTypeId, 'titleKey')) {
                            <div class="title-key-2">
                              {{getTitleKeyOfTridy(getTRIDYIdData(incom.tridyId, 'payload'), getContentTypeFieldById(incom.contentTypeId, 'titleKey'))}}
                            </div>
                          }
                          @if (getContentTypeFieldById(incom.contentTypeId, 'subtitleKeys')) {
                            <div>
                              @for (subtitle of getSubtitleKeyOfTridy(getTRIDYIdData(incom.tridyId, 'payload'), getContentTypeFieldById(incom.contentTypeId, 'subtitleKeys')); track subtitle) {
                                <div>
                                  @if (subtitle?.contentType === 'public.image') {
                                    <div class="subtitle-key-2">{{subtitle.fileName}}</div>
                                  }
                                  @if (subtitle?.contentType !== 'public.image') {
                                    <div class="subtitle-key-2">{{subtitle}}</div>
                                  }
                                </div>
                              }
                            </div>
                          }
                          @if (!getContentTypeFieldById(incom.contentTypeId, 'titleKey') && !getContentTypeFieldById(incom.contentTypeId, 'subtitleKeys')) {
                            <span class="title-key-2">
                              {{getContentTypeFieldById(incom.contentTypeId, 'displayName')}}
                            </span>
                          }
                        </div>
                      }
                      @if (!getTRIDYIdData(incom.tridyId, 'payload')) {
                        <div>
                          <span class="title-key-2">
                            {{getContentTypeFieldById(incom.contentTypeId, 'displayName')}}
                          </span>
                        </div>
                      }
                      <div class="mt-1">ID: {{incom.tridyId}}</div>
                      <div class="d-flex flex-column text-muted">
                        @if (getTRIDYIdData(incom.tridyId, 'creationDate')) {
                          <span>
                            {{'creation_date' | translate}}: {{getTRIDYIdData(incom.tridyId, 'creationDate').toDate() | date:'dd.MM.yyyy, HH:mm' }}
                          </span>
                        }
                        @if (getTRIDYIdData(incom.tridyId, 'timeStamp')) {
                          <span>
                            {{'last_update' | translate}}: {{getTRIDYIdData(incom.tridyId, 'timeStamp').toDate() | date:'dd.MM.yyyy, HH:mm' }}
                          </span>
                        }
                      </div>
                    </div>
                    <span class="material-symbols-outlined" style="color:var(--warmOrange);">
                      keyboard_arrow_right
                    </span>
                  </div>
                </div>
              }
            </mat-card-content>
          </mat-card>
        </div>
      }

      <!-- OUTGOING -->
      @if (outgoing && outgoing.length!=0) {
        <div>
          <div class="my-4 section-title">
            <mat-icon class="custom-card-icon material-symbols-outlined">output</mat-icon>{{'workTask.outgoing_tridys' | translate}}
          </div>
          <mat-card class="mb-2">
            <mat-card-content class="my-2">
              @for (out of outgoing; track out) {
                <div class="item-content my-1" (click)="openTridyDetailsDialog(out.tridyId)">
                  <div class="d-flex flex-row flex-nowrap justify-content-between align-items-center">
                    <div class="d-flex flex-column flex-nowrap">
                      @if (getTRIDYIdData(out.tridyId, 'payload')) {
                        <div>
                          @if (getContentTypeFieldById(out.contentTypeId, 'titleKey')) {
                            <div class="title-key-2">
                              {{getTitleKeyOfTridy(getTRIDYIdData(out.tridyId, 'payload'), getContentTypeFieldById(out.contentTypeId, 'titleKey'))}}
                            </div>
                          }
                          @if (getContentTypeFieldById(out.contentTypeId, 'subtitleKeys')) {
                            <div>
                              @for (subtitle of getSubtitleKeyOfTridy(getTRIDYIdData(out.tridyId, 'payload'), getContentTypeFieldById(out.contentTypeId, 'subtitleKeys')); track subtitle) {
                                <div>
                                  @if (subtitle?.contentType === 'public.image') {
                                    <div class="subtitle-key-2">{{subtitle.fileName}}</div>
                                  }
                                  @if (subtitle?.contentType !== 'public.image') {
                                    <div class="subtitle-key-2">{{subtitle}}</div>
                                  }
                                </div>
                              }
                            </div>
                          }
                          @if (!getContentTypeFieldById(out.contentTypeId, 'titleKey') && !getContentTypeFieldById(out.contentTypeId, 'subtitleKeys')) {
                            <span class="title-key-2">
                              {{getContentTypeFieldById(out.contentTypeId, 'displayName')}}
                            </span>
                          }
                        </div>
                      }
                      @if (!getTRIDYIdData(out.tridyId, 'payload')) {
                        <div>
                          <span class="title-key-2">
                            {{getContentTypeFieldById(out.contentTypeId, 'displayName')}}
                          </span>
                        </div>
                      }
                      <div class="mt-1">ID: {{out.tridyId}}</div>
                      <div class="d-flex flex-column text-muted">
                        @if (getTRIDYIdData(out.tridyId, 'creationDate')) {
                          <span>
                            <!--NAr-2570-->
                            {{'creation_date' | translate}}: {{getTRIDYIdData(out.tridyId, 'creationDate').toDate() ? (getTRIDYIdData(out.tridyId, 'creationDate').toDate() | date:'dd.MM.yyyy, HH:mm') : '' }}
                          </span>
                        }
                        @if (getTRIDYIdData(out.tridyId, 'timeStamp')) {
                          <span>
                            <!--NAr-2570-->
                            {{'last_update' | translate}}: {{getTRIDYIdData(out.tridyId, 'timeStamp').toDate() ? (getTRIDYIdData(out.tridyId, 'timeStamp').toDate() | date:'dd.MM.yyyy, HH:mm') : '' }}
                          </span>
                        }
                      </div>
                    </div>
                    <span class="material-symbols-outlined" style="color:var(--warmOrange);">
                      keyboard_arrow_right
                    </span>
                  </div>
                </div>
              }
            </mat-card-content>
          </mat-card>
        </div>
      }

      <!-- DISPLAY TEMPLATE -->
      @if (contentTypeData?.displaySections) {
        <div>
          <div class="my-4 section-title">
            <mat-icon class="custom-card-icon material-symbols-outlined">description</mat-icon>{{'tridys.payloadData' | translate}}
          </div>
          @for (group of contentTypeData.displaySections; track group) {
            <div>
              <mat-card class="mb-4">
                <mat-card-header>
                  <strong>{{group.title}}</strong>
                </mat-card-header>
                <mat-card-content class="p-3">
                  @for (field of group.fields; track field; let last = $last) {
                    <div>
                      <div class="d-flex justify-content-between">
                        <div class="py-2 px-4 key-styles"><span class="font-weight-bold">{{field.title}}</span></div>
                        <div class="py-2 px-4 value-styles">
                          <span>{{getPayloadDataByFieldKey(field.key)}}</span>
                        </div>
                      </div>
                      @if (!last) {
                        <mat-divider></mat-divider>
                      }
                    </div>
                  }
                </mat-card-content>
              </mat-card>
            </div>
          }
        </div>
      }

      <!-- show all button -->
      <div class="w-100 d-flex justify-content-center">
        @if (contentTypeData?.displaySections) {
          <button mat-button
            [class.d-none]="contentTypeData?.displaySections && showAll"
            (click)="showAllPayload()"
            class="mt-1 mb-4 secondary-gray-button">
            {{'showAll' | translate}}
          </button>
        }
      </div>

      <!-- all payload -->
      <div #payloadCard [class.d-none]="contentTypeData?.displaySections && !showAll">
        <div class="my-4 section-title">
          <mat-icon class="custom-card-icon material-symbols-outlined">description</mat-icon>{{'tridys.allPayloadData' | translate}}
        </div>

        <mat-card class="mb-4">
          <mat-card-content class="p-3">
            @if (allpayload.length==0) {
              <div class="p-3">
                <span class="text-muted">{{'tridys.no_payload_data' | translate}}</span>
              </div>
            }
            @for (payload of allpayload; track payload; let last = $last; let index = $index) {
              <div>
                @if (!isObject(payload[1])) {
                  <div class="d-flex justify-content-between">
                    <!-- <div class="input-group mt-1 mb-1 w-100" *ngIf="payload[0]!='name' && payload[0]!='description' && payload[0]!='tagline' && payload[0]!='array' && payload[0]!='map'"> -->
                    <div class="py-2 px-4 key-styles"><span class="font-weight-bold">{{payload[0]}}</span></div>
                    <div class="py-2 px-4 value-styles">
                      @if (!payload[1].nanoseconds && !payload[1].seconds && !matchingDate(payload[1])) {
                        <span>{{payload[1]}}</span>
                      }
                      @if (!payload[1].nanoseconds && !payload[1].seconds && matchingDate(payload[1])) {
                        <span>{{payload[1] | date: 'dd.MM.yyyy, HH:mm'}}</span>
                      }
                      @if (payload[1].nanoseconds || payload[1].seconds) {
                        <span>{{payload[1].toDate() | date: 'dd.MM.yyyy, HH:mm' }}</span>
                      }
                    </div>
                  </div>
                }
                @if (isObject(payload[1]) && payload[1].contentType) {
                  <div class="d-flex justify-content-between">
                    <div class="py-2 px-4 key-styles">
                      <span class="font-weight-bold">{{payload[0]}}</span> <span class="material-symbols-outlined text-muted" style="vertical-align: middle;font-size: 20px;">attach_file</span>
                    </div>
                    <div class="py-2 px-4 value-styles">
                      @if (!fileName[payload[0]] && mediaData && media) {
                        <div>
                          @if (payload[1]?.fileName) {
                            <a href="{{urlData[payload[0]]}}" class="pdf-title" target="_blank">
                              <mat-icon class="material-symbols-outlined">open_in_new</mat-icon>{{payload[1].fileName}}
                            </a>
                          }
                        </div>
                      }
                      @if (fileName[payload[0]] && mediaData && media && media[payload[0]]) {
                        <div>
                          @if (urlData[payload[0]]) {
                            <a href="{{urlData[payload[0]]}}" target="_blank" style="cursor:zoom-in;">
                              <img src="{{urlData[payload[0]]}}" style="height:150px;width:auto;">
                            </a>
                          }
                        </div>
                      }
                    </div>
                  </div>
                }
                @if (isObject(payload[1]) && !payload[1].contentType) {
                  <div class="d-flex justify-content-between">
                    <div class="py-2 px-4 key-styles"><span class="font-weight-bold">{{payload[0]}}</span></div>
                    @if (!payload[1]) {
                      <span class="py-2 px-4 value-styles"> - </span>
                    }
                    @if (payload[1] && !payload[1].nanoseconds && !payload[1].seconds) {
                      <span class="py-2 px-4 value-styles">
                        <div [app-tridys-item-tree-data]="[payload[0], payload[1], index]"> </div>
                      </span>
                    }
                    @if (payload[1] && payload[1].nanoseconds || payload[1].seconds) {
                      <span class="py-2 px-4 value-styles"> {{payload[1].toDate() | date: 'dd.MM.yyyy, HH:mm' }} </span>
                    }
                  </div>
                }
                @if (!last) {
                  <mat-divider></mat-divider>
                }
              </div>
            }
          </mat-card-content>
        </mat-card>

        <div class="mb-4">
          @if (tridyArray) {
            <mat-accordion class="w-100 mt-4">
              <mat-expansion-panel (opened)="panelOpenState=true" (closed)="panelOpenState=false">
                <mat-expansion-panel-header>
                  <mat-panel-title>
                    {{'tridys.array' | translate}}
                  </mat-panel-title>
                  <mat-panel-description>
                  </mat-panel-description>
                </mat-expansion-panel-header>
                @for (array of tridyArray; track array) {
                  <p>{{array}}</p>
                }
              </mat-expansion-panel>
            </mat-accordion>
          }
          @if (tridyMap) {
            <mat-accordion class="w-100 mt-2">
              <mat-expansion-panel (opened)="panelOpenState = true" (closed)="panelOpenState = false">
                <mat-expansion-panel-header>
                  <mat-panel-title>
                    {{'tridys.map' | translate}}
                  </mat-panel-title>
                  <mat-panel-description>
                  </mat-panel-description>
                </mat-expansion-panel-header>
                @for (map of tridyMap | keyvalue; track map) {
                  <p> {{map.key}} : {{map.value}}</p>
                }
              </mat-expansion-panel>
            </mat-accordion>
          }
        </div>
      </div>
    </div>
  </div>
</section>


